export const getPaginationRange = (currentPage, totalPages) => {
  if (!totalPages || totalPages <= 0) return [];
  if (currentPage > totalPages) currentPage = totalPages;
  if (currentPage < 1) currentPage = 1;

  const range = [];
  const maxPagesToShow = 5;

  if (totalPages <= maxPagesToShow) {
    for (let i = 1; i <= totalPages; i++) {
      range.push(i);
    }
  } else {
    let start = Math.max(1, currentPage - 2);
    let end = Math.min(totalPages, currentPage + 2);

    if (start === 1) {
      end = maxPagesToShow;
    } else if (end === totalPages) {
      start = totalPages - maxPagesToShow + 1;
    }

    if (start > 1) {
      range.push(1);
      if (start > 2) range.push('...');
    }

    for (let i = start; i <= end; i++) {
      range.push(i);
    }

    if (end < totalPages) {
      if (end < totalPages - 1) range.push('...');
      range.push(totalPages);
    }
  }

  return range;
};

export const formatCellData = (value, type) => {
  if (value === null || value === undefined) return '-';
  
  if (type === 'currency') {
    const num = parseFloat(value);
    if (isNaN(num)) return '-';
    return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(num);
  }
  
  if (type === 'date') {
    const date = new Date(value);
    if (isNaN(date.getTime())) return '-';
    return new Intl.DateTimeFormat('pt-BR').format(date);
  }

  return String(value);
};



// WEBPACK FOOTER //
// ./src/design-system/molecules/TableData/utils/tableDataHelpers.js